"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tableau_ui_1 = require("@tableau/tableau-ui");
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
var Declarative_1 = require("../utils/Declarative");
var ActivitySpinnerSize;
(function (ActivitySpinnerSize) {
    ActivitySpinnerSize[ActivitySpinnerSize["Large"] = 50] = "Large";
    ActivitySpinnerSize[ActivitySpinnerSize["Small"] = 14] = "Small";
})(ActivitySpinnerSize = exports.ActivitySpinnerSize || (exports.ActivitySpinnerSize = {}));
/**
 * An inline activity spinner.
 *
 * NOTE: A DOM ancestor of the ActivitySpinnerWidget should have `aria-busy=true`
 */
exports.ActivitySpinnerWidget = React.forwardRef(function (props, ref) {
    return React.createElement(tableau_ui_1.Spinner, { alt: Localize_1.Messages.waitIndicatorLabel(), color: props.onDarkBackground ? 'light' : 'dark', "data-tb-test-id": Declarative_1.makeTestId(props.testId, 'Spinner'), dimension: props.spinnerSize, ref: ref, role: 'img', showUnderlay: props.shouldShowUnderlay });
});
exports.ActivitySpinnerWidget.defaultProps = { spinnerSize: ActivitySpinnerSize.Large };
exports.ActivitySpinnerWidget.displayName = 'ActivitySpinnerWidget';
//# sourceMappingURL=ActivitySpinnerWidget.js.map